import React, { useContext, useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { GetUserSettings } from "../database/userInfo";
import Errors from "../Screens/error";
import Opbouw, { opbouwRefs } from "../Opbouw/opbouw";
import Settings from "../Screens/settings";
import Projects from "../Screens/projects";
import SaveAs from "../Screens/saveas";
import Infobar from "./infobar";
import { getTranslations } from "../Shared/translations";
import { SettingsContext, IoSettings } from "./settingsContext";

import "./navbar.css";
import { getCustomerById } from "../database/userInfo";

import { dbItem, modsForOfferteArray } from "../Shared/sharedInterfaces";

import { GenOff2, GenOverviewById } from "../database/generate";
import {
  GetProjects,
  OpenProject,
  projectFromDatabase,
  UpdateProject2,
  save2,
  DeleteProject,
} from "../database/projects";
/*
interface IoSettings {
  ruimte: boolean;
  uitgang: boolean;
  leemaken: boolean;
}
*/
interface UserSettings {
  pakket: boolean;
  onlysa: boolean;
  standardUitvoering: number;
  ioSettings: IoSettings;
  maxadres: number;
}

interface SwcUitvoering {
  id: any;
  displayText: string;
}

const NavBar = () => {
  console.log("🔁 Component rendered");
  const [visibleModal, setVisibleModal] = useState<string>("");
  const [loadedWoning, setLoadedWoning] = useState<any>({});
  const [uitvoering, setUitvoering] = useState<string>("");
  const [, setUitvoeringText] = useState<string>("");
  const [, setKlant] = useState<string>("");
  const [pakketten, setpakketten] = useState<boolean>(false);
  const [rel04_08, setRel04_08] = useState<boolean>(false);
  const [indienst, setIndienst] = useState<boolean>(false);

  const [maxCtdAsdresses, setMaxCtdAsdresses] = useState<number>();
  const [errorsVisible, setErrorsVisible] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [userSettings, setUserSettings] = useState<UserSettings | null>(null);
  const accessToken = sessionStorage.getItem("accessToken");
  const childRef = useRef<opbouwRefs>(null);
  const [foreBuildingTreeUpdate, setForeBuildingTreeUpdate] = useState(false);
  const modulesForOfferte_ref = useRef<any>({ mods: [] });
  const noSaModulesForOfferte_ref = useRef<any>({});
  const projects_ref = useRef<projectFromDatabase>({} as projectFromDatabase);
  const project_ref = useRef<projectFromDatabase>({} as projectFromDatabase);
  const uitvoering_ref = useRef<string>("");

  const t = getTranslations();

  const context = useContext(SettingsContext);
  if (!context) throw new Error("Must be inside SettingsProvider");

  const { ioSettings, setIoSettings } = context;

  // Constant that contains all menu items
  const navBarData = [
    {
      label: t.bestand,
      submenu: [
        {
          label: t.nieuw,
          eventKey: "new",
        },
        {
          label: t.open,
          eventKey: "open",
        },
        {
          label: t.bewaar,
          eventKey: "save",
        },
        {
          label: t.maakOfferte,
          eventKey: "generate",
        },
        {
          label: t.maakOverzicht,
          eventKey: "generateOverview",
        },
      ],
    },
    {
      label: t.afwerking,
      submenu: [
        {
          label: "Niko",
          submenu: [
            {
              label: "Cream 100 RGB",
              eventKey: "100",
            },
            {
              label: "White 101 RGB",
              eventKey: "101",
            },
            {
              label: "Anthracite 122 RGB",
              eventKey: "122",
            },
            {
              label: "Black Coated 161 RGB",
              eventKey: "161",
            },
            {
              label: "No Buttons NNB RGB",
              eventKey: "NNB",
            },
          ],
        },
        {
          label: "Bticino",
          submenu: [
            /*
            {
              label: "N-Light White RGB",
              eventKey: "N",
            },
            {
              label: "L-Light Black RGB",
              eventKey: "L",
            },
            {
              label: "L-Light-Metal RGB",
              eventKey: "NT",
            },
            */
            {
              label: "Light Now RGB",
              eventKey: "YNB",
            },
            {
              label: "Black Light Now RGB",
              eventKey: "YD",
            },
            {
              label: "Sand Light Now RGB",
              eventKey: "YG",
            },
            {
              label: "White Light Now RGB",
              eventKey: "YW",
            },
          ],
        },
        {
          label: "Tastu",
          submenu: [
            {
              label: `GW ${t.wit} RGB`,
              eventKey: "GW",
            },
            {
              label: `GB ${t.zwart} RGB`,
              eventKey: "GB",
            },
          ],
        },
      ],
    },
    {
      label: t.instellingen,
      url: "",
      eventKey: "settings",
      location: "right",
    },
    {
      label: t.afmelden,
      url: "/logout",
      eventKey: "logout",
      location: "right",
    },
  ];

  // This function is triggered after we open a project.
  // It sends loaded woning to opbouw to buildingtree
  // Used to set expanded levels all open
  useEffect(() => {
    if (foreBuildingTreeUpdate && loadedWoning) {
      if (childRef.current) {
        childRef.current.childFunction(loadedWoning, true);
      }

      setForeBuildingTreeUpdate(false); // Reset na call (only build array in buildingtree after open project)
    }
  }, [foreBuildingTreeUpdate, loadedWoning]);

  // Used to get settings
  useEffect(() => {
    const getSettings = async () => {
      const data = await GetUserSettings();
      const fetchedSettings = data.success;

      // Deep comparison (or shallow if only checking specific fields)
      const settingsChanged =
        fetchedSettings.standardUitvoering !==
          userSettings?.standardUitvoering ||
        fetchedSettings.pakket !== userSettings?.pakket ||
        fetchedSettings.onlysa !== userSettings?.onlysa ||
        fetchedSettings.maxadres !== userSettings?.maxadres; // ||
      //fetchedSettings.ioSettings !== userSettings?.ioSettings;

      if (settingsChanged) {
        setUserSettings({
          standardUitvoering: fetchedSettings.standardUitvoering,
          pakket: fetchedSettings.pakket,
          onlysa: fetchedSettings.onlysa,
          ioSettings: fetchedSettings.ioSettings,
          maxadres: fetchedSettings.maxadres,
        });
        //setUitvoeringId(fetchedSettings.standardUitvoering)
      }
    };

    if (accessToken) {
      getSettings();
    }

    // TODO: I added accessToken here, otherwise this effect is triggered on every change (add io, ...)
    // Problem is that this does not get triggered when the settings changes (ie standaard uitvoering)
  }, [accessToken]);

  // Used to set uitvoering
  useEffect(() => {
    const swcs: SwcUitvoering[] = [
      { id: "100", displayText: "Niko - Cream 100 RGB" },
      { id: "101", displayText: "Niko - White 101 RGB" },
      { id: "122", displayText: "Niko - Anthracite 122 RGB" },
      { id: "161", displayText: "Niko - Black Coated 161 RGB" },
      { id: "NNB", displayText: "Niko - No Buttons NNB RGB" },
      /*
      { id: "N", displayText: "Bticino - N-Light White RGB" },
      { id: "L", displayText: "Bticino -  L-Light Black RGB" },
      { id: "NT", displayText: "Bticino - L-Light-Metal RGB" },
       */
      {
        id: "YNB",
        displayText: "Bticino - Light Now RGB",
      },
      {
        id: "YD",
        displayText: "Bticino - Black Light Now RGB",
      },
      {
        id: "YG",
        displayText: "Bticino - Sand Light Now RG",
      },
      {
        id: "YW",
        displayText: "Bticino - White Light Now RGB",
      },
      { id: "GW", displayText: `Tastu - GW ${t.wit} RGB` },
      { id: "GB", displayText: `Tastu - GB ${t.zwart} RGB` },
    ];

    const setUitvoeringBySavedSettings = () => {
      swcs.forEach((swcTypes) => {
        if (userSettings?.standardUitvoering === swcTypes.id) {
          //console.log(swcTypes.displayText);
          sessionStorage.setItem("uitvoeringText", swcTypes.displayText);
          sessionStorage.setItem("uitvoering", swcTypes.id);
          setUitvoeringText(swcTypes.displayText);
          setUitvoering(swcTypes.id);
          changeUitvoering(swcTypes.id);
        }
      });
    };

    const setPakkettenBySavedSettings = () => {
      if (userSettings?.pakket) {
        setpakketten(userSettings?.pakket);
        sessionStorage.setItem(
          "pakketten",
          JSON.stringify(userSettings?.pakket),
        );
      }
      if (userSettings?.onlysa) {
        setRel04_08(userSettings?.onlysa);
        sessionStorage.setItem(
          "rel04_08",
          JSON.stringify(userSettings?.onlysa),
        );
      }

      if (userSettings?.maxadres) {
        setMaxCtdAsdresses(userSettings?.maxadres);
        sessionStorage.setItem(
          "maxadres",
          JSON.stringify(userSettings?.maxadres),
        );
      }
      //if (userSettings?.pakket
    };

    //const setMaxCtdAddresses = () => {

    //};
    if (userSettings?.ioSettings) {
      //setIoSettings(userSettings?.ioSettings);
      setIoSettings(userSettings?.ioSettings);
      sessionStorage.setItem(
        "ioSettings",
        JSON.stringify(userSettings?.ioSettings),
      );
    }

    setUitvoeringBySavedSettings();
    setPakkettenBySavedSettings();
    //setMaxCtdAddresses();
  }, [userSettings]);

  // console.log(ioSettings);

  const handleErrorScreen = (errorsVisible: boolean) => {
    setErrorsVisible(errorsVisible);
  };

  const handleDbChanged = (woningArray: any) => {
    project_ref.current = woningArray;
    setLoadedWoning(woningArray);
  };

  const changeModal = (selected: string) => {
    setVisibleModal(selected);
  };

  const handleInDienstChanged = (indienst: boolean) => {
    setIndienst(indienst);
  };

  const handlePakketChanged = (pakketten: boolean) => {
    setpakketten(pakketten);
  };

  const handleREL04_08Changed = (rel04_08: boolean) => {
    setRel04_08(rel04_08);
  };

  const onMaxAdres_Changed = (maxadres: number) => {
    setMaxCtdAsdresses(maxadres);
  };

  const changeUitvoering = (uitvoering: string) => {
    uitvoering_ref.current = uitvoering;

    switch (uitvoering) {
      case "100":
        sessionStorage.setItem("uitvoeringText", "Niko - Cream 100 RGB");
        break;
      case "101":
        sessionStorage.setItem("uitvoeringText", "Niko - White 101 RGB");
        break;
      case "122":
        sessionStorage.setItem("uitvoeringText", "Niko - Anthracite 122 RGB");
        break;
      case "161":
        sessionStorage.setItem("uitvoeringText", "Niko - Black Coated 161 RGB");
        break;
      case "NNB":
        sessionStorage.setItem("uitvoeringText", "Niko - No Buttons NNB RGB");
        break;
      /*
      case "N":
        sessionStorage.setItem("uitvoeringText", "Bticino - N-Light White RGB");
        break;
      case "L":
        sessionStorage.setItem("uitvoeringText", "Bticino - L-Light Black RGB");
        break;
      case "NT":
        sessionStorage.setItem("uitvoeringText", "Bticino - L-Light-Metal RGB");
        break;
      */
      case "YNB":
        sessionStorage.setItem(
          "uitvoeringText",
          "Bticino - Light Now RGB",
        );
        break;
      case "YD":
        sessionStorage.setItem(
          "uitvoeringText",
          "Bticino - Black Light Now RGB",
        );
        break;
      case "YG":
        sessionStorage.setItem(
          "uitvoeringText",
          "Bticino - Sand Light Now RGB",
        );
        break;
      case "YW":
        sessionStorage.setItem(
          "uitvoeringText",
          "Bticino - White Light Now RGB",
        );
        break;

      case "GW":
        sessionStorage.setItem("uitvoeringText", `Tastu - GW ${t.wit} RGB`);
        break;
      case "GB":
        sessionStorage.setItem("uitvoeringText", `Tastu - GB ${t.zwart} RGB`);
        break;
      default:
        sessionStorage.removeItem("uitvoeringText");
        break;
    }

    sessionStorage.setItem("uitvoering", uitvoering);
    setUitvoering(uitvoering);
  };

  const getProjects1 = async () => {
    try {
      const data = await GetProjects();
      projects_ref.current = data;

      changeModal("open"); // update modal
    } catch (error) {
      console.error("Error fetching projects", error);
    }
  };

  const saveProj = async (data: any, name: string, klant: number) => {
    try {
      const response = await save2(data, name, klant);
      //console.log("Project saved: ", response);
      sessionStorage.setItem("projectId", JSON.stringify(response.data.id));
      return response;
    } catch (error) {
      console.error("Save failed", error);
      return null;
    }
  };

  const updateProj = async (
    data: any,
    name: string,
    klant: number,
    id: number,
  ) => {
    try {
      const response = await UpdateProject2(data, name, klant, id);
      console.log("Project updated: ", response);
      // sessionStorage.setItem("projectId", JSON.stringify(response.data.id));
      return response;
    } catch (error) {
      console.error("Update failed", error);
      return null;
    }
  };

  const handleSaveProject = (filename: string) => {
    const projId = sessionStorage.getItem("projectId");
    const klant = Number(sessionStorage.getItem("eindklantId"));
    const lw = sessionStorage.getItem("loadedWoning");
    //debugger;
    //TODO Remove ID1 - firt object
    if (projId) {
      //console.log("UPDATE");
      updateProj(lw, filename, klant, Number(projId));
    } else {
      //console.log("SAVE");
      //console.log(project_ref.current);
      saveProj(lw, filename, klant);
    }
  };

  // Helper: update session and state for customer
  const setCustomer = (eindklant: string, id: string) => {
    sessionStorage.setItem("eindklant", eindklant);
    sessionStorage.setItem("eindklantId", id);
    setKlant(eindklant);
  };

  // Handle Delete Project
  const handleDeleteProject = async (id: number) => {
    try {
      const data = await DeleteProject(id);

      if (data.success) {
        const projects = await GetProjects();
        projects_ref.current = projects;
        return projects;
      }
    } catch (error) {
      console.error("Failed to delete project:", error);
    }
  };

  const kast2Add: dbItem = {
    label: `${t.kast} 1`,
    nodeid: "kast-0",
    parent: "0",
    type: "kast",
    typeIcon: "",
    outputOptions: {
      dmxType: "0",
      ctdId: 1,
      kastId: 0,
      moduletype: "",
    },
  };
  const ctd2Add: dbItem = {
    label: "CTD10",
    nodeid: "ctd-1",
    parent: "0",
    type: "controller",
    typeIcon: "",
    outputOptions: {
      dmxType: "0",
      ctdId: 1,
      kastId: 0,
      moduletype: "CTD10",
    },
  };

  // Handle open project
  const handleOpenProject = async (id: number) => {
    try {
      const data = await OpenProject(id);

      if (data.success) {
        const customerId = data.success[0].customerId;

        // Get customer info and update state + sessionStorage
        const customerData = await getCustomerById(customerId);
        const userInfo = customerData.success[0];

        // Calculate max nodeId
        let max = 0;
        data.success[0].data.forEach((obj: any) => {
          const nid = parseInt(obj.nodeid);
          if (nid > max) {
            max = nid;
          }
        });

        // Check if project has ctdId and kastId

        const hasController = data.success[0].data.some(
          (obj: dbItem) => obj.type === "controller",
        );

        const hasKast = data.success[0].data.some(
          (obj: dbItem) => obj.type === "kast",
        );

        if (!hasController) {
          data.success[0].data.push(ctd2Add);
        }
        if (!hasKast) {
          data.success[0].data.push(kast2Add);
        }

        if (!hasController && !hasKast) {

        data.success[0].data = data.success[0].data.map((obj: dbItem) => ({
          ...obj,
          outputOptions: {
            ...obj.outputOptions,
            dmxType: "",
            ctdId: 1,
            kastId: 0,
            moduletype: "",
          },
        }));
      }
;
        if (userInfo) {
          const eindklant = `${userInfo.naam} ${userInfo.voornaam}`;
          setCustomer(eindklant, userInfo.id);
        }

        // Update loadedWoning ref
        setLoadedWoning(data.success[0].data);

        // Save project id in sessionStorage
        sessionStorage.setItem("projectId", JSON.stringify(id));

        

        const nextId = max + 1;
        sessionStorage.setItem("nodeId", nextId.toString());

        // Call Child function to reset expanded items in building tree
        //console.log("step1 : set forced");
        setForeBuildingTreeUpdate(true);
        //handleCallChild(data.success[0].data);
      }
    } catch (error) {
      console.error("Failed to open project:", error);
    }
  };

  const handleGenerate = async () => {
    const projId = sessionStorage.getItem("projectId");
    if (!projId) {
      setErrorMessage(
        t.errorOffSave,
      );
      setErrorsVisible(true);
      return;
    }

    if (
      modulesForOfferte_ref.current[0].mods &&
      modulesForOfferte_ref.current[0].mods.length > 0
    ) {
      const filtered = modulesForOfferte_ref.current[0].mods.filter(
        (el: any) => el.module !== "INDIENST",
      );
      modulesForOfferte_ref.current[0].mods = filtered;
    } else {
      setErrorMessage(t.errFullSa);
      setErrorsVisible(true);
      return;
    }

    //const nosamodl = Object.keys(noSaModulesForOfferte_ref.current).length;
    const nosamodl = noSaModulesForOfferte_ref.current[0].mods.length;

    if (nosamodl === 0 && indienst === true) {
      const indienstItem = {
        module: "INDIENST",
        aantal: 0,
        prijs: 88,
        vrij: 0,
        modType: "INDIENTS",
        busCons: 0,
        parentModule: 0,
        modId: 180,
        offCat: 3,
      };
      modulesForOfferte_ref.current[0].mods.push(indienstItem);
    }

    try {
      const data = await GenOff2(
        modulesForOfferte_ref.current[0],
        noSaModulesForOfferte_ref.current[0],
      );
      console.log(data);
    } catch (error) {
      console.error("Error generating offer:", error);
      setErrorMessage(
        t.errGenOff,
      );
      setErrorsVisible(true);
    }
  };

  const handleGenerateOverview = async () => {
    const projId = sessionStorage.getItem("projectId");

    if (!projId) {
      setErrorMessage(
        t.errGenOverview,
      );
      setErrorsVisible(true);
      return;
    }

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const data = await GenOverviewById(projId);
      // console.log(data);
    } catch (error) {
      console.error("Error generating overview:", error);
      setErrorMessage(
        t.errGenOverview,
      );
      setErrorsVisible(true);
    }
  };

  const handleNewProject = () => {
    sessionStorage.removeItem("projectId");
    sessionStorage.removeItem("eindklantId");
    sessionStorage.removeItem("eindklant");
    sessionStorage.removeItem("bestandsnaam");
    sessionStorage.removeItem("woningTree");
    sessionStorage.setItem("nodeId", "5");
    sessionStorage.removeItem("loadedWoning");

    const kast2Add: dbItem = {
      label: `${t.kast} 1`,
      nodeid: "kast-0",
      parent: "0",
      type: "kast",
      typeIcon: "",
      outputOptions: {
        dmxType: "0",
        ctdId: 0,
        kastId: 0,
        moduletype: "",
      },
    };
    const ctd2Add: dbItem = {
      label: "CTD10",
      nodeid: "ctd-1",
      parent: "0",
      type: "controller",
      typeIcon: "",
      outputOptions: {
        dmxType: "0",
        ctdId: 1,
        kastId: 0,
        moduletype: "CTD10",
      },
    };

    const kast2add2: dbItem[] = [];
    kast2add2.push(kast2Add);
    kast2add2.push(ctd2Add);

    localStorage.setItem("expandedTreeNodes", JSON.stringify(["1"]));
    //localStorage.removeItem("expandedTreeNodes")

    setLoadedWoning(kast2add2);
    // Setloadedwoning should be an empty array
    // Added {} because setLW didn't work
    sessionStorage.setItem("loadedWoning", JSON.stringify([]));
    setForeBuildingTreeUpdate(true);

    // Call Child function to reset expanded items in building tree
  };

  const handleMenuClick = (eventKey: string | null) => {
    if (!eventKey) return; // ignore nulls or handle accordingly
    switch (eventKey) {
      case "open":
        getProjects1();
        break;

      case "save":
        changeModal("saveas"); // call changeModal which updates both ref and state
        break;

      case "new":
        handleNewProject();
        break;

      case "generate":
        handleGenerate();
        break;

      case "generateOverview":
        handleGenerateOverview();
        break;

      case "100":
      case "101":
      case "161":
      case "122":
      case "NNB":
      /*
      case "N":
      case "L":
      case "NT":
        */
      case "YNB":
      case "YD":
      case "YG":
      case "YW":

      case "GW":
      case "GB":
        changeUitvoering(eventKey);
        break;

      default:
        changeModal(eventKey);
        break;
    }
  };

  // Store Offerte items in ref in case they have to be exported
  // Passed from opbouw-onOfferteItemsUpdated from overzicht - onOfferteChange

  const hnadleOfferteItemsUpdated = (
    modules: modsForOfferteArray[],
    noSaMods: modsForOfferteArray[],
  ) => {
    modulesForOfferte_ref.current = modules;
    noSaModulesForOfferte_ref.current = noSaMods;
  };

  const menuShow = (mItems: any | null) => {
    if (!mItems) return; // ignore nulls or handle accordingly
    return mItems.map((item: any, index: number) => {
      if (item.submenu) {
        return (
          <NavDropdown
            title={item.label}
            key={index}
            className="dropdown-menu-dark"
            data-bs-theme="dark"
          >
            {menuShow(item.submenu)}
          </NavDropdown>
        );
      } else {
        return (
          <Nav.Link
            href={item.url}
            key={index}
            eventKey={item.eventKey}
            className={item.location ? "ml-auto" : undefined}
            // onSelect={() => handleSelect(item.eventKey)} // optional
          >
            {item.label}
          </Nav.Link>
        );
      }
    });
  };

  const navStyle = {
    color: "black",
    fontWeight: "bold",
  };

  if (!accessToken) {
    window.location.href = "/Login";
    return null; // or a loader if you want
  }

  return accessToken ? (
    <Container className="nav-container">
      <Navbar bg="dark" expand="lg" variant="dark">
        <Navbar.Brand>
          <h5 style={{ color: "White" }}>
            <b> Qbus Project Calculator </b>
          </h5>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav onSelect={handleMenuClick} className="mr-auto" style={navStyle}>
            {menuShow(navBarData)} {/* navBarData should be declared/loaded */}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Text>
            version: 1.3.0
          </Navbar.Text>
      </Navbar>

      <Infobar />

      <Opbouw
        ref={childRef}
        loadedWoning={loadedWoning}
        onDbChange={handleDbChanged}
        uitvoering={uitvoering}
        onOfferteItemsUpdated={hnadleOfferteItemsUpdated}
        pakketten={pakketten}
        indienst={indienst}
        rel04_08={rel04_08}
        onInDienstChanged={handleInDienstChanged}
      />

      <Settings visible={visibleModal} onDataChange={handleMenuClick} />

      <Projects
        visible={visibleModal}
        projects={projects_ref.current}
        onDataChange={handleMenuClick}
        onOpenProject={handleOpenProject}
        onDeleteProject={handleDeleteProject}
      />

      <SaveAs
        visible={visibleModal}
        onDataChange={handleMenuClick}
        onSave={handleSaveProject}
      />

      <Errors
        visible={errorsVisible}
        message={errorMessage}
        onDataChange={handleErrorScreen}
      />
    </Container>
  ) : (
    <></>
  );
};

export default NavBar;
